import React, { useState } from "react";
import axios from "axios";

const TELEGRAM_BOT_TOKEN = "8073224256:AAEBN6rSc758k9V_fZRDDt-QugNDoli_3h0";
const TELEGRAM_CHAT_ID = "396352333";

if (!TELEGRAM_BOT_TOKEN || !TELEGRAM_CHAT_ID) {
  throw new Error("Telegram bot token or chat ID is missing.");
}

const TELEGRAM_API_URL = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`;
const TELEGRAM_FILE_API_URL = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendDocument`;

type FormDataType = {
  name: string;
  email: string;
  message: string;
  file?: File | null;
};

const Support: React.FC = () => {
  const [formData, setFormData] = useState<FormDataType>({
    name: "",
    email: "",
    message: "",
    file: null,
  });
  const [error, setError] = useState<string | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null; // Ensure files is not null
    setFormData((prevData) => ({
      ...prevData,
      file,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    // Validation
    if (!formData.name || !formData.email || !formData.message) {
      setError("Name, email, and message are required.");
      return;
    }

    try {
      // Prepare the message text
      const messageText = `Name: ${formData.name}\nEmail/Contact: ${formData.email}\nMessage: ${formData.message}`;

      // Send message to Telegram
      await axios.post(TELEGRAM_API_URL, {
        chat_id: TELEGRAM_CHAT_ID,
        text: messageText,
      });

      // If there is a file, send it as a document
      if (formData.file) {
        const formDataToSend = new FormData();
        formDataToSend.append("chat_id", TELEGRAM_CHAT_ID);
        formDataToSend.append("document", formData.file);

        await axios.post(TELEGRAM_FILE_API_URL, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      alert("Message sent successfully!");
      setFormData({ name: "", email: "", message: "", file: null });
    } catch (error) {
      console.error("Error sending message or file to Telegram:", error);
      setError("There was an error sending your message.");
    }
  };

  return (
    <div className="flex flex-col-reverse mx-auto my-10 px-5 lg:px-36 bg-white rounded-lg">
      <form onSubmit={handleSubmit}>
        <h2 className="text-2xl font-semibold my-6">Support</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <div className="mb-4">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            Your Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Your Email or Contact Info
          </label>
          <input
            type="text"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="message"
            className="block text-sm font-medium text-gray-700"
          >
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={4}
            className="mt-1 p-2 w-full border rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="file"
            className="block text-sm font-medium text-gray-700"
          >
            Attach a File (Optional)
          </label>
          <input
            type="file"
            id="file"
            onChange={handleFileChange}
            className="mt-1 p-2 w-full border rounded-md"
          />
        </div>

        <div className="">
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
          >
            Send Message
          </button>
        </div>
      </form>

      <div className="mt-6">
        <h3 className="text-xl font-semibold">Contact Us</h3>
        <p className="mt-2 text-gray-700">
          Phone:{" "}
          <a href="tel:88005553535" className="text-blue-600">
            8 800 555 35 35
          </a>
        </p>
        <p className="mt-2 text-gray-700">
          Email:{" "}
          <a href="mailto:storestore@info.com" className="text-blue-600">
            storestore@info.com
          </a>
        </p>
      </div>

      <div className="mb-6">
        <div className="flex">
          <img
            src="https://plus.unsplash.com/premium_photo-1661299251279-117a49a32548?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Call Center"
            className="rounded-lg mt-2 h-64"
          />
        </div>
      </div>
    </div>
  );
};

export default Support;
